/* eslint-disable jsx-a11y/anchor-is-valid */
import Sheet from '@mui/joy/Sheet';
import Table from '@mui/joy/Table';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useStore } from '../store/StoreContext';
import { Box, Switch, Typography } from '@mui/joy';
import { Position } from 'store/domain/leaderboard/leaderboard';
import { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Symbol } from 'components/Symbol';

export const TraderPositionsTable = () => (
  <React.Fragment>
    <Sheet
      className="OrderTableContainer"
      variant="outlined"
      sx={{
        display: {
          xs: 'none',
          sm: 'initial',
        },
        width: '100%',
        borderRadius: 'sm',
        flexShrink: 1,
        overflow: 'auto',
        minHeight: 0,
      }}
    >
      <Table
        aria-labelledby="tableTitle"
        stickyHeader
        hoverRow
        sx={{
          '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
          '--Table-headerUnderlineThickness': '1px',
          '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
          '--TableCell-paddingY': '4px',
          '--TableCell-paddingX': '8px',
        }}
      >
        <thead>
          <tr>
            <th style={{ width: '48px' }} />
            <th>Symbol</th>
            <th>Qty</th>
            <th>Value</th>
            <th>Entry price</th>
            <th>Mark price</th>
            <th>PNL</th>
            <th>ROE</th>
          </tr>
        </thead>
        <TraderPositionsTableBody />
      </Table>
    </Sheet>
  </React.Fragment>
);

export const TraderPositionsTableBody = observer(() => {
  const { id } = useParams();
  const { leaderboard } = useStore();
  const positions = leaderboard.getSelectedFollowersPositions(id);

  return (
    <Box
      component="tbody" sx={{ fontSize: 10 }}
    >
      {positions.map(position => (
        <ExpandableRow position={position} key={position.symbol} />
      ))}
    </Box>
  );
});

export const ExpandableRow = observer(({
  position: {
    symbol,
    entryPrice,
    markPrice,
    pnl,
    roe,
    amount,
    long,
    leverage,
    formattedValue,
  },
}: { position: Position }) => {
  const [isExpanded, setExpanded] = useState(false);
  return (
    <Fragment>
      <tr>
        <th>
          <Switch
            checked={isExpanded}
            onChange={event => setExpanded(event.target.checked)}
          />
        </th>
        <th>
          <Symbol symbol={symbol} leverage={leverage} isLong={long} />
        </th>
        <th>
          <Typography sx={{ color: long ? 'green' : 'red' }}>
            {amount}
          </Typography>
        </th>
        <th>
          {formattedValue}
        </th>
        <th>
          {entryPrice}
        </th>
        <th>
          {markPrice}
        </th>
        <th>
          {pnl}
        </th>
        <th>
          {roe}
        </th>
      </tr>
      {isExpanded && (
        <tr>
          <th />
          <th />
          <th>
            <Typography sx={{ color: long ? 'green' : 'red' }}>
              {amount}
            </Typography>
          </th>
          <th>
            {formattedValue}
          </th>
          <th>
            {entryPrice}
          </th>
          <th>
            {markPrice}
          </th>
          <th>
            {pnl}
          </th>
          <th>
            {roe}
          </th>
        </tr>
      )}
    </Fragment>
  );
});
